export const ITEMS_BOOSTERS_CATEGORIES: ListItem[] = [{
    "key": "building",
    "label": "Building",
}, {
    "key": "research",
    "label": "Research",
}, {
    "key": "general",
    "label": "General",
}];

export const ITEMS_TIME_BOOSTERS_CATEGORIES: ListItem[] = [{
    "key": "cash",
    "label": "Cash",
}, {
    "key": "energy",
    "label": "Energy",
}, {
    "key": "army",
    "label": "Army",
}, {
    "key": "hero",
    "label": "Hero",
}];

export const ITEMS_CATEGORIES: ListItem[] = [{
    "key": "free",
    "label": "Free",
}, {
    "key": "normal",
    "label": "Normal",
}, {
    "key": "district",
    "label": "District",
}, {
    "key": "special",
    "label": "Special",
}, {
    "key": "tournament",
    "label": "Tournament",
}, {
    "key": "hq",
    "label": "HQ",
}, {
    "key": "vip",
    "label": "VIP",
}];

export const ITEMS_RARITY: ListItem[] = [{
    "key": "common",
    "label": "Common",
}, {
    "key": "rare",
    "label": "Rare",
}, {
    "key": "epic",
    "label": "Epic",
}, {
    "key": "legendary",
    "label": "Legendary",
}];

export const ITEMS_GEAR_PACK: ListItem[] = [{
    "key": "9",
    "label": "Common",
}, {
    "key": "18",
    "label": "Rare",
}, {
    "key": "19",
    "label": "Epic",
}, {
    "key": "20",
    "label": "Legendary",
}];

export const ITEMS_RESOURCE: ListItem[] = [{
    "key": "honey",
    "label": "Cash",
}, {
    "key": "flowers",
    "label": "Energy",
}, {
    "key": "rubies",
    "label": "Gems",
}];

export interface ItemTemplate {
    type: string;
    listData: ListItem[];
    template: TemplateItem[];
}

interface ListItem {
    key: string;
    label: string;
}

export interface TemplateItem {
    key: string;
    label: string;
    type: "input" | "file" | "select",
    values?: ListItem[];
    format?: string;
    disabled?: boolean;
}
